import { render, staticRenderFns } from "./tab-secondary.vue?vue&type=template&id=22fd3b00&scoped=true&"
import script from "./tab-secondary.vue?vue&type=script&lang=js&"
export * from "./tab-secondary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22fd3b00",
  null
  
)

export default component.exports